import React, { Component } from 'react';
import HomeComponent from './components';
import { MainLayout } from '../../common/components';

class Home extends Component {
    render() {
        //const isBusy = (!this.props.user.isProfileReady && this.props.user.profile.isAuthenticated) || this.props.user.isLoggingIn;
        return (
            <MainLayout {...this.props}>
                <HomeComponent
                    {...this.props}
                    isBusy={false} />
            </MainLayout>
        );
    }
}

export default Home;

